// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17Gyg","largestCol":"styles_largestCol__2QJ4O","smallestCol":"styles_smallestCol__1wA7u"};